var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 2.08317L11.6668 3.99986C11.6668 4.93328 11.6668 5.39999 11.8485 5.75651C12.0083 6.07012 12.2632 6.32509 12.5768 6.48487C12.9334 6.66653 13.4001 6.66653 14.3335 6.66653L16.2502 6.66653M16.6668 8.5946L16.6668 11.6665C16.6668 14.0001 16.6668 15.1668 16.2127 16.0581C15.8132 16.8421 15.1758 17.4796 14.3918 17.879C13.5005 18.3332 12.3337 18.3332 10.0002 18.3332C7.66661 18.3332 6.49983 18.3332 5.60853 17.879C4.82452 17.4796 4.18711 16.8421 3.78763 16.0581C3.33349 15.1668 3.33349 14.0001 3.33349 11.6665L3.33349 8.14832C3.3335 5.98898 3.3335 4.90931 3.72399 4.07203C4.13796 3.1844 4.85139 2.47097 5.73902 2.057C6.5763 1.6665 7.65597 1.6665 9.81531 1.66651C10.7589 1.66651 11.2307 1.66651 11.6762 1.7653C12.1507 1.8705 12.603 2.05788 13.0129 2.31897C13.3978 2.56418 13.7314 2.89778 14.3986 3.56498L14.7142 3.88055C15.4348 4.60118 15.7952 4.9615 16.0528 5.38199C16.2813 5.75479 16.4496 6.16122 16.5517 6.58637C16.6668 7.06591 16.6668 7.57547 16.6668 8.5946Z",
    stroke: "#6E707A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 8.3335,
    width: 16.6667,
    height: 7.5,
    rx: 2,
    fill: "#D7EADC",
    stroke: "#379552",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.4165L8.75 13.7498",
    stroke: "#379552",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 10.4165L4.1665 13.7498",
    stroke: "#379552",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 13.7498L13.3335 10.4165L15.4168 10.4165",
    stroke: "#379552",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 12.5L15.4168 12.5",
    stroke: "#379552",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 10.4165L5.62484 10.4165C6.20013 10.4165 6.6665 10.8829 6.6665 11.4582V11.4582C6.6665 12.0335 6.20013 12.4998 5.62484 12.4998L4.1665 12.4998",
    stroke: "#379552",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.4165L9.58333 10.4165C10.5038 10.4165 11.25 11.1627 11.25 12.0832V12.0832C11.25 13.0036 10.5038 13.7498 9.58333 13.7498L8.75 13.7498",
    stroke: "#379552",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.70f27463.svg";
export { ForwardRef as ReactComponent };